import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { AuthService } from '../_service/auth.service';
import { SharedService } from '../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    authErr:boolean;submitted = false;loading:boolean=false;notifyVersionUpdate:string='false';
    constructor(private formBuilder: FormBuilder,private authapi:AuthService, private sharedapi:SharedService,private router:Router)
    {
        this.loginForm = this.formBuilder.group({
           'mobile' : [null, Validators.required],
            'password' : [null, Validators.required]
        });


    }

  ngOnInit(): void {
    this.authapi.checkappVersion()
        .subscribe((data:any) => {
        if(data.err=="app_version"){
            $('#versionModal').modal();
        }
    })

  }
  ngAfterViewInit(){

  }

    async signin()
    {
        this.submitted = true;
        this.loading = true;
        // stop here if form is invalid
        if (this.loginForm.invalid) {
            this.loading = false;
            return;
        }
        this.loginForm.value.device_source = 1;
        this.loginForm.value.push_token = localStorage.getItem('push_token');
        await this.authapi.login(this.loginForm.value)
        .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('Login Successful');
                localStorage.setItem('currentUser',data.user.auth_token);
                localStorage.setItem('username',data.user.name);
                localStorage.setItem('loginuserId',data.user.id);
                localStorage.setItem('role',data.user.role);
                localStorage.setItem('role_name',data.user.role_name);
                localStorage.setItem('passwordstatus',data.user.passwordstatus);
                localStorage.setItem('insuranceAllAccess',data.user.ins_all_access);
                localStorage.setItem('CMAccess',data.user.is_cm_access);
                localStorage.setItem('is_preSales',data.user.is_presales_access);
                localStorage.setItem('treatment_catergory_access',data.user.treatment_catergory_access);
                localStorage.setItem('user_catergory_access',data.user.treatmentCatIds);

                localStorage.setItem('meeting_room_access',data.user.meeting_room_access);
                localStorage.setItem('userLeadSource',data.user.lead_source_id);
                localStorage.setItem('is_doctor_access',data.user.is_doctor_access);
                localStorage.setItem('mark_as_affiliate',data.user.mark_as_affiliate);
                let profilePic= 'assets/images/defalutpic.png';
                if(data.user.image!=null)
                profilePic = data.s3url+data.user.image;
                localStorage.setItem('profile_pic',profilePic);
                localStorage.setItem('s3url',data.s3url);
                this.sharedapi.setUsername(data.user.name);
                this.sharedapi.setUserId(data.user.id);
                this.sharedapi.setProfilePic(profilePic);
                 this.sharedapi.setRole(data.user.role);
                 this.sharedapi.setCMAccess(data.user.is_cm_access);
                 this.sharedapi.setLeadSourceOfUse(data.user.lead_source_id);
                 this.sharedapi.setlogin(true);
                setTimeout (() => {
                    if(localStorage.getItem('rdr') && localStorage.getItem('rdr')!='')
                    {
                        let rdr = localStorage.getItem('rdr');
                        localStorage.removeItem('rdr')
                        this.router.navigate([rdr]);
                    }else if(localStorage.getItem('passwordstatus') && localStorage.getItem('passwordstatus')=='0'){
                        this.router.navigate(['/profile']);
                    }else if(localStorage.getItem('role') =='19'){
                        this.router.navigate(['/scan-booked-list']);
                    }else if(localStorage.getItem('role') =='7'){
                        this.router.navigate(['/opds']);
                    }
                    else
                    this.router.navigate(['/dashboard']);
                }, 100);
            }
            else
            {
                this.authErr = true;
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }
    get f() { return this.loginForm.controls; }

    reloadScreen(){
        window.location.reload();
    }

}
